export default (initialState = {}) => {
  return () => {
    return {
      address: "",
      city: "",
      state_cd: "",
      pincode: "",
      country: "",
      country_cd: "",
      directors: [
        {
          name: "",
          phone: "",
          pan: "",
          aadhar: "",
          date_of_birth: "",
          credit_score: null,
          is_primary: false,
        },
      ],
      fssai: "",
      fssai_expiration_date: null,
      udyam_aadhar: "",
      msme_category: "",
      gstin: null,
      pan: null,
      is_gst_registered: true,
      shop_name: "",
      legal_business_name: "",
      business_type: null,
      registration_date: null,
      incorporation_date: null,
      number_of_director: 1,
      gstin_status: "",
      filing_frequency: "",
      latest_gst_filed: null,
      gst_filing_status_count: null,
      total_gross_income: null,
      annual_aggregate_turnover: "",
      aggregate_turnover_range: { minimum: null, maximum: null },
      is_msme_registered: false,
      is_trade_msme: false,
      ...initialState,
    };
  };
};
